import axios from 'axios';
import moment from 'moment';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [
    ],
    loaded : false,
    addNew : false,
    types_updating : [],
})

  // getters
  const getters = {
    getPayments: (state) => (type) =>{
      return state.list.filter(item => item.calculation == type);
   },
   getPaymentsTableRow: (state, getters) => (type) => {
     var payments = getters.getPayments(type);
     var tmp = [];
     if(payments.length > 0){
             for(let i = 0; i < payments.length; i++){
                 var subtract = 0;
             var add = 0;
             if(payments[i].direction == "out"){
                 subtract = _.get(payments[i], "amount", 0);
             }
             if(payments[i].direction == "in"){
                 add =  _.get(payments[i], "amount", 0);
             }
             if(add == null || add == Number.NaN || add == undefined){
                add = 0;
             }
             if(subtract == null || subtract == Number.NaN || subtract == undefined){
              subtract = 0;
           }
             tmp.push(
                 {
                     name : (payments[i].invoice_number ?? '') + ' ' + (payments[i].name ?? ''),
                     add :  parseFloat(add),
                     subtract: parseFloat(subtract),
                     paid : payments[i].paied_date,
                     id : payments[i].id,
                 }
             );
         }
        }
        return tmp;
      },
    getTotalBalance: (state, getters) => (type) => {
      var tmp = {
        add: 0,
        subtract : 0,
        diff: 0,
      };
      var tableRows = getters.getPaymentsTableRow(type);
      if(tableRows.length > 0){

        for(let i = 0; i < tableRows.length;i++){
          tmp.add = parseFloat(_.get(tmp, "add", 0) + parseFloat(_.get(tableRows, "["+i+"].add", 0)));
          tmp.subtract = parseFloat(_.get(tmp, "subtract", 0) + parseFloat(_.get(tableRows, "["+i+"].subtract", 0)));
        }
        tmp.diff = parseFloat(_.get(tmp, "add", 0) - parseFloat(_.get(tmp, "subtract", 0)));
        tmp.add = parseFloat(_.get(tmp, "add", 0));
        tmp.subtract = parseFloat(_.get(tmp, "subtract", 0));
        tmp.diff = parseFloat(_.get(tmp, "diff", 0));
      }
      return tmp;
    }
  }

  // actions
  const actions = {
    async save({commit, state, rootState}, data){
        if(data.id == 0){
          await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/payment", data).then((response) => {
                commit("update", response.data.data);
            });
        }else{
            await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/payment/" + data.id, data).then((response) => {
                commit("update", response.data.data);
            })
        }
    },
    async delete({commit, state, rootState}, data) {
      if (data.data.url !== undefined && data.data.ids.length > 0) {
          for (var i = 0; i < data.data.ids.length; i++) {
              var url = data.data.url + "/" + data.data.ids[i];
              await axios.delete(url).then(response => {
                  commit("remove", data.data.ids[i]);
              }).catch(error => {
              });
          }
      }
    },
    async getShinkibaCosts({commit, state, rootState}, data) {
      await axios.get(rootState.settings.url + "/api/extern/v1/shinkibaCostsFromOrder?orderId=" + data.orderId).then((response) => {
        if (response.data.data !== undefined) {
          commit("init", response.data.data);
        }
      });
    }
  }

  // mutations
  const mutations = {
      clear(state){
          state.list = [];
      },
      init(state, data){
          state.list = data;
      },
      unshift(state, data){
        state.list.unshift(data);
      },
      push(state, data){
        state.list.push(data);
      },
      update(state, data){
        var index = state.list.findIndex(item => item.id == data.id);
        if(index > -1){
            state.list[index] = data;
        }else{
            state.list.push(data);
        }
      },
      remove(state, id){
        var index = state.list.findIndex(item => item.id == id);
        if(index > -1){
          state.list.splice(index, 1);
        }
      },
      types_updating(state, types){
        state.types_updating = types;
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
